var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrainerIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3615 18.2224C16.3365 17.9599 19.5019 14.7579 19.7622 10.7382C19.8126 9.95193 19.8126 9.1372 19.7622 8.3509C19.5019 4.3322 16.3365 1.13203 12.3615 0.867713C10.9887 0.777494 9.61132 0.777494 8.23844 0.867713C4.26354 1.13108 1.09805 4.3322 0.837747 8.35184C0.787422 9.14683 0.787422 9.9442 0.837747 10.7392C0.932749 12.2029 1.58162 13.5585 2.34639 14.7029C2.79005 15.5034 2.49744 16.5029 2.03478 17.3773C1.70227 18.0073 1.53507 18.3218 1.66902 18.5492C1.80202 18.7766 2.10128 18.7841 2.69885 18.7984C3.88163 18.8268 4.6787 18.4933 5.31141 18.0282C5.66957 17.7638 5.84913 17.6322 5.97263 17.617C6.09613 17.6018 6.34029 17.7023 6.8267 17.9012C7.26371 18.0812 7.77198 18.1921 8.23749 18.2233C9.59128 18.3124 11.0059 18.3124 12.3625 18.2233",
    stroke: "currentColor",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrainerIcon);
export default __webpack_public_path__ + "static/media/trainer-icon.3547cc097551601a8f60f080ec675bd8.svg";
export { ForwardRef as ReactComponent };